import qs from 'query-string'
import { useQueryClient } from 'react-query'

import { useMutationApi, useQueryApi } from 'utils/api'

import type {
  RequestDeleteKinerjaHarian,
  RequestGetKinerjaHarianContents,
  RequestGetKinerjaHarianLogs,
  RequestUpsertKinerjaHarian,
  ResponseDeleteKinerjaHarian,
  ResponseGetKinerjaHarianContent,
  ResponseGetKinerjaHarianLogs,
  RequestGetKinerjaHarianActive,
  ResponseGetKinerjaHarianActive,
} from 'types/kinerja-harian'
import type { CustomError } from 'types/custom-error'

const basePath = '/guru/pps/v1/pps/kinerja-harian'

export const API_GET_KINERJA_HARIAN_LOGS_QUERY_KEY =
  'API_GET_KINERJA_HARIAN_LOGS_PS_QUERY_KEY'

export function useAPIGetKinerjaHarianLogs({
  params,
  options,
}: RequestGetKinerjaHarianLogs) {
  const rawParams = {
    start_date: params.startDate,
    end_date: params.endDate,
  }

  return useQueryApi<ResponseGetKinerjaHarianLogs>(basePath, {
    axiosConfig: {
      params: rawParams,
    },
    queryConfig: options,
    queryKey: [API_GET_KINERJA_HARIAN_LOGS_QUERY_KEY, rawParams],
  })
}

const API_GET_KINERJA_HARIAN_CONTENTS_QUERY_KEY =
  'API_GET_KINERJA_HARIAN_CONTENTS_PS_QUERY_KEY'
export function useAPIGetKinerjaHarianContents({
  params,
  options,
}: RequestGetKinerjaHarianContents) {
  const path = `${basePath}/konten`

  return useQueryApi<ResponseGetKinerjaHarianContent>(path, {
    axiosConfig: {
      params: {
        role: params.role,
        tipe: params.tipe,
        requested_date: params.requestedDate,
      },
    },
    queryConfig: options,
    queryKey: [API_GET_KINERJA_HARIAN_CONTENTS_QUERY_KEY, params],
  })
}

export function useAPIPostUpsertKinerjaHarian() {
  return useMutationApi<
    {
      message: string
      meta: {
        skpYear: number
        skpPeriod: number
      }
    },
    CustomError,
    RequestUpsertKinerjaHarian
  >(basePath, {
    axiosConfig: { method: 'POST' },
  })
}

export function useAPIDeleteKinerjaHarian() {
  const queryClient = useQueryClient()

  return useMutationApi<
    ResponseDeleteKinerjaHarian,
    CustomError,
    RequestDeleteKinerjaHarian
  >((data: RequestDeleteKinerjaHarian) => `${basePath}?${qs.stringify(data)}`, {
    axiosConfig: { method: 'DELETE' },
    mutationConfig: {
      onSuccess: () => {
        queryClient.invalidateQueries(API_GET_KINERJA_HARIAN_LOGS_QUERY_KEY)
      },
    },
  })
}

export function useAPIGetKinerjaHarianActive({
  params,
  options,
}: RequestGetKinerjaHarianActive) {
  const path = `${basePath}/active`
  const rawParams = {
    skpYear: params?.skpYear,
    skpPeriod: params?.skpPeriod,
    ...(params.tipe && { tipe: params.tipe }),
  }

  return useQueryApi<ResponseGetKinerjaHarianActive>(path, {
    queryConfig: {
      ...options,
    },
    axiosConfig: {
      params: rawParams,
    },
    queryKey: [path, rawParams],
  })
}
